"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _DeleteValue = _interopRequireDefault(require("./DeleteValue.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteValue = function DeleteValue(_ref) {
  var _onClick = _ref.onClick;
  var css = (0, _DeleteValue.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.deleteValue, "mco-form-delete-value"),
    onClick: function onClick(e) {
      e.stopPropagation();

      if (_onClick) {
        _onClick();
      }
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"
  })));
};

var _default = DeleteValue;
exports.default = _default;